import React from "react";
import { Grow, Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";

const tableCellStyle = { color: "#222" };

export default function CheckItemGroupTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            {/*Empty grid for alignment*/}
            {props.warningList.length <= 0 ? <Grid item xs={1} sm={3} md={2}></Grid> : <Grid item md={1}></Grid>}
            <Grid item xs={10} sm={6} md={7}>
                <div style={{ overflow: "auto", height: "auto" }}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{t("ID")}</TableCell>
                                <TableCell align="center">{t("Name")}</TableCell>
                                <TableCell align="center">{t("Note")}</TableCell>
                                <TableCell align="center">{t("StartDate")}</TableCell>
                                <TableCell align="center">{t("EndDate")}</TableCell>
                                <TableCell align="center">{t("CheckItemName")}</TableCell>
                                <TableCell align="center">{t("CheckItemNote")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.checkItemGroupExcel.map((row) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.excelRowNumber}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.groupDefinition}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.groupNote}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {moment(new Date(row.validityStartDate)).format("DD.MM.YYYY")}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {moment(new Date(row.validityEndDate)).format("DD.MM.YYYY")}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.itemDefinition}
                                    </TableCell>
                                    <TableCell sx={tableCellStyle} align="center">
                                        {row.itemNote}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={2} sm={6} md={4}>
                {props.warningList.length > 0 && props.checkItemGroupExcel.length > 0 ? (
                    <>
                        <Grid item md={1}></Grid>
                        <Grid item md={8}>
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <TableContainer  style={{ backgroundColor: "#FF9089" }}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">{t("Line")}</TableCell>
                                                <TableCell align="center">{t("Warnings")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.warningList.map((row) => (
                                                <TableRow>
                                                    <TableCell sx={tableCellStyle} align="center">
                                                        {row.rowNumber - 1}
                                                    </TableCell>
                                                    <TableCell sx={tableCellStyle} align="center">
                                                        {row.message}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grow>
                        </Grid>
                        <Grid item md={1}></Grid>
                    </>
                ) : null}
            </Grid>
            {/*Empty grid for alignment*/}
            <LoadingBackdrop id="cigt_lbd" />
        </Grid>
    );
}
